import { render, staticRenderFns } from "./PatentCard.vue?vue&type=template&id=0a10ef68"
import script from "./PatentCard.vue?vue&type=script&lang=js"
export * from "./PatentCard.vue?vue&type=script&lang=js"
import style0 from "./PatentCard.vue?vue&type=style&index=0&id=0a10ef68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports